// Define image compare function.
let players = {}; // Store players in an object
const intervalMap = {};
var vimeoPlayers = {};
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];

firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// Suppress Firefox YouTube widget API console errors and warnings
(function() {
	if (typeof window !== 'undefined' && window.console) {
		// Function to check if error should be filtered
		const shouldFilter = (args) => {
			const message = args.join(' ');
			const hasWidgetError = message.includes('An invalid or illegal string was specified') ||
								   message.includes('www-widgetapi.js') ||
								   (message.includes('DOMException') && message.includes('widgetapi'));
			
			// Also check individual arguments for error objects
			for (let arg of args) {
				if (arg instanceof Error && arg.message && 
					arg.message.includes('An invalid or illegal string was specified')) {
					return true;
				}
				if (typeof arg === 'string' && arg.includes('www-widgetapi.js')) {
					return true;
				}
			}
			
			return hasWidgetError;
		};

		// Filter console.error
		if (window.console.error) {
			const originalConsoleError = window.console.error;
			window.console.error = function(...args) {
				if (shouldFilter(args)) return;
				originalConsoleError.apply(console, args);
			};
		}
		
		// Filter console.warn
		if (window.console.warn) {
			const originalConsoleWarn = window.console.warn;
			window.console.warn = function(...args) {
				if (shouldFilter(args)) return;
				originalConsoleWarn.apply(console, args);
			};
		}
		
		// Filter console.log (some errors might be logged here)
		if (window.console.log) {
			const originalConsoleLog = window.console.log;
			window.console.log = function(...args) {
				if (shouldFilter(args)) return;
				originalConsoleLog.apply(console, args);
			};
		}

		// Override window.onerror for uncaught exceptions
		const originalOnError = window.onerror;
		window.onerror = function(message, source, lineno, colno, error) {
			if (message && typeof message === 'string') {
				if (message.includes('An invalid or illegal string was specified') ||
					(source && source.includes('www-widgetapi.js'))) {
					return true; // Prevent default error handling
				}
			}
			if (originalOnError) {
				return originalOnError.call(this, message, source, lineno, colno, error);
			}
			return false;
		};
	}
})();

// Initialize HTML5 video elements with start and end time controls
const html5PausedVideos = new Map();

function initHTML5VideoPlayers() {
	document
		.querySelectorAll("video.coca-image-compare-before, video.coca-image-compare-after")
		.forEach(function (videoElement) {
			const startTime = parseFloat(videoElement.dataset.startTime) || 0;
			const endTime = parseFloat(videoElement.dataset.endTime) || videoElement.duration;
			const hasLoop = videoElement.hasAttribute("loop");
			const hasAutoPlay = videoElement.hasAttribute("autoplay");
			const playPauseContainer =
				videoElement.parentElement.parentElement.parentElement.parentElement.lastElementChild.firstElementChild;

			if (hasAutoPlay) {
				playPauseContainer.children[1].classList.remove("hidden");
				playPauseContainer.children[1].classList.add("show");
				playPauseContainer.children[0].classList.remove("show");
				playPauseContainer.children[0].classList.add("hidden");
			}

			// Set initial time to start time
			if (startTime > 0) {
				videoElement.currentTime = startTime;
			}

			// Add timeupdate event listener to handle end time
			if (endTime > 0) {
				videoElement.addEventListener("timeupdate", function () {
					if (this.currentTime >= endTime) {
						if (hasLoop) {
							this.currentTime = startTime;
						} else {
							// Check if auto slide is enabled - if so, don't change the icon state
							const container = $(this).closest('.coca-image-compare-container');
							const autoSlideEnabled = container.data('auto-slide-enabled') === true || 
													container.attr('data-auto-slide-enabled') === 'true' ||
													container.attr('data-auto-slide-enabled') === '1';
							
							// Only change to play icon if auto slide is NOT enabled
							if (!autoSlideEnabled) {
								playPauseContainer.children[0].classList.remove("hidden");
								playPauseContainer.children[0].classList.add("show");
								playPauseContainer.children[1].classList.remove("show");
								playPauseContainer.children[1].classList.add("hidden");
							}
							
							this.pause();
							this.currentTime = startTime;
						}
					}
				});
			}

			// Add play event listener to ensure it starts from start time
			videoElement.addEventListener("play", function () {
				if (this.currentTime < startTime || (endTime > 0 && this.currentTime > endTime)) {
					this.currentTime = startTime;
				}
			});

			document.addEventListener("visibilitychange", () => {
				const videos = document.querySelectorAll(
					"video.coca-image-compare-before, video.coca-image-compare-after",
				);

				if (document.hidden) {
					// Pause and remember current time
					videos.forEach((video) => {
						if (!video.paused && !video.ended) {
							html5PausedVideos.set(video, video.currentTime);
							video.pause();
						}
					});
				} else {
					// Resume from stored time
					html5PausedVideos.forEach((time, video) => {
						video.currentTime = time;
						video.play();
					});
					html5PausedVideos.clear();
				}
			});
		 });
}

// function initYouTubePlayers() {
// 	if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
// 		setTimeout(initYouTubePlayers, 100);
// 		return;
// 	}

// 	// Initialize players for each video container
// 	document.querySelectorAll(".coca-video-compare-wrapper").forEach(function (container) {
// 		const tagName = container.firstElementChild.firstElementChild.tagName;
// 		const playPause = container.parentElement.parentElement.lastChild;
// 		const children = playPause.children;

// 		if (tagName !== "" && tagName === "IFRAME") {
// 			const firstIframe = container.firstElementChild.firstElementChild;
// 			const lastIframe = container.lastElementChild.firstElementChild;

// 			if (!players[firstIframe.id]) {
// 				players[firstIframe.id] = new YT.Player(firstIframe.id, {
// 					playerVars: {
// 						controls: 0,
// 						rel: 0,
// 						fs: 0,
// 						mute: 1,
// 						enablejsapi: 1,
// 					},
// 					events: {
// 						onReady: (event) => {
// 							if (intervalMap[firstIframe.id]) {
// 								clearInterval(intervalMap[firstIframe.id]);
// 							}

// 							const youtubeUrl = new URL(event.target.g.src);
// 							const { start, end, autoplay, loop } = Object.fromEntries(
// 								youtubeUrl.searchParams.entries(),
// 							);

// 							const startTime = parseFloat(start || 0);
// 							const endTime = parseFloat(end || event.target.getDuration());

// 							if (autoplay) {
// 								if (!isNaN(startTime)) {
// 									event.target.seekTo(startTime, true);
// 								}
// 								children[0].children[1].classList.remove("hidden");
// 								children[0].children[1].classList.add("show");
// 								children[0].children[0].classList.remove("show");
// 								children[0].children[0].classList.add("hidden");

// 								event.target.playVideo();
// 							}

// 							// Setup loop interval
// 							const intervalId = setInterval(() => {
// 								const currentTime = event.target.getCurrentTime();
// 								if (loop) {
// 									if (!isNaN(endTime) && Math.round(currentTime) >= endTime) {
// 										event.target.seekTo(startTime, true);
// 										event.target.playVideo();
// 									}
// 								} else {
// 									if (currentTime > endTime) {
// 										children[0].children[0].classList.remove("hidden");
// 										children[0].children[0].classList.add("show");
// 										children[0].children[1].classList.remove("show");
// 										children[0].children[1].classList.add("hidden");
// 									}
// 								}
// 							}, 500);

// 							// Store the interval ID to clean later
// 							intervalMap[firstIframe.id] = intervalId;
// 						},
// 					},
// 				});
// 			}

// 			if (!players[lastIframe.id]) {
// 				players[lastIframe.id] = new YT.Player(lastIframe.id, {
// 					playerVars: {
// 						controls: 0,
// 						rel: 0,
// 						fs: 0,
// 						mute: 1,
// 						enablejsapi: 1,
// 					},
// 					events: {
// 						onReady: (event) => {
// 							if (intervalMap[lastIframe.id]) {
// 								clearInterval(intervalMap[lastIframe.id]);
// 							}
// 							const youtubeUrl = new URL(event.target.g.src);
// 							const { start, end, loop } = Object.fromEntries(youtubeUrl.searchParams.entries());

// 							const startTime = parseFloat(start || 0);
// 							const endTime = parseFloat(end || event.target.getDuration());

// 							// Setup loop interval
// 							const intervalId = setInterval(() => {
// 								const currentTime = event.target.getCurrentTime();
// 								if (loop) {
// 									if (!isNaN(endTime) && Math.round(currentTime) >= endTime) {
// 										event.target.seekTo(startTime, true);
// 										event.target.playVideo();
// 									}
// 								} else {
// 									if (currentTime > endTime) {
// 										children[0].children[0].classList.remove("hidden");
// 										children[0].children[0].classList.add("show");
// 										children[0].children[1].classList.remove("show");
// 										children[0].children[1].classList.add("hidden");
// 									}
// 								}
// 							}, 500);

// 							// Store the interval ID to clean later
// 							intervalMap[lastIframe.id] = intervalId;
// 						},
// 					},
// 				});
// 			}
// 		}
// 	});
// }

function initYouTubePlayers() {
	if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
		setTimeout(initYouTubePlayers, 100);
		return;
	}

	// Initialize players for each video container
	document.querySelectorAll(".coca-video-compare-wrapper").forEach(function (container) {
		const tagName =
			container?.firstElementChild?.firstElementChild?.tagName ||
			container?.lastElementChild?.firstElementChild?.tagName;
		const playPause = container.parentElement.parentElement.lastChild;
		const children = playPause.children;

		if (tagName !== "" && tagName === "IFRAME") {
			const firstIframe = container.firstElementChild.firstElementChild;
			const lastIframe = container.lastElementChild.firstElementChild;

			if (firstIframe?.id && !players[firstIframe?.id]) {
				players[firstIframe.id] = new YT.Player(firstIframe.id, {
					playerVars: {
						controls: 0,
						rel: 0,
						fs: 0,
						mute: 1,
						enablejsapi: 1,
					},
					events: {
						onReady: (event) => {
							// Clean up any existing intervals/animation frames
							if (intervalMap[firstIframe.id]) {
								// Could be either setInterval or requestAnimationFrame
								if (typeof intervalMap[firstIframe.id] === "function") {
									intervalMap[firstIframe.id]();
								} else {
									clearInterval(intervalMap[firstIframe.id]);
								}
							}

							const youtubeUrl = new URL(event.target.g.src);
							const { start, end, autoplay, loop } = Object.fromEntries(
								youtubeUrl.searchParams.entries(),
							);

							const startTime = parseFloat(start || 0);
							// Safe getDuration call with fallback
							let endTime;
							if (end) {
								endTime = parseFloat(end);
							} else if (typeof event.target.getDuration === 'function') {
								try {
									endTime = event.target.getDuration();
								} catch (e) {
									endTime = null;
								}
							}

							if (autoplay && autoplay !== "0") {
								if (!isNaN(startTime)) {
									event.target.seekTo(startTime, true);
								}
								children[0].children[1].classList.remove("hidden");
								children[0].children[1].classList.add("show");
								children[0].children[0].classList.remove("show");
								children[0].children[0].classList.add("hidden");

								event.target.playVideo();
							}

							// Setup requestAnimationFrame loop for smoother performance
							let rafId;
							let lastCheckTime = 0;

							// Check video only every 200ms to reduce CPU usage
							const checkVideoTime = (timestamp) => {
								// Throttle checks to reduce CPU usage (check every 200ms)
								if (timestamp - lastCheckTime >= 200) {
									lastCheckTime = timestamp;
									const currentTime = event.target.getCurrentTime();

									if (loop && loop !== "0") {
										if (!isNaN(endTime) && Math.round(currentTime) >= endTime) {
											event.target.seekTo(startTime, true);
											event.target.playVideo();
										}
									} else {
										if (Math.ceil(currentTime) >= endTime) {
											children[0].children[0].classList.remove("hidden");
											children[0].children[0].classList.add("show");
											children[0].children[1].classList.remove("show");
											children[0].children[1].classList.add("hidden");
											cancelAnimationFrame(rafId);
											return;
										}
									}
								}

								// Continue the loop only if player is playing (state 1)
								if (event.target.getPlayerState() === YT.PlayerState.PLAYING) {
									rafId = requestAnimationFrame(checkVideoTime);
								}
							};

							// Start the animation frame loop
							rafId = requestAnimationFrame(checkVideoTime);

							// Handle state changes to manage rAF loop
							event.target.addEventListener("onStateChange", (stateEvent) => {
								if (stateEvent.data === YT.PlayerState.PLAYING) {
									// Resume animation frame loop when video plays
									rafId = requestAnimationFrame(checkVideoTime);
								} else if (
									stateEvent.data === YT.PlayerState.PAUSED ||
									stateEvent.data === YT.PlayerState.ENDED
								) {
									// Stop animation frame loop when video is paused or ended
									cancelAnimationFrame(rafId);
								}
							});

							const pausedPlayers = {}; // Track paused players and their current times

							document.addEventListener("visibilitychange", () => {
								if (document.hidden) {
									// Tab is hidden — pause all playing videos
									Object.entries(players).forEach(([id, player]) => {
										console.dir(typeof player.getPlayerState);
										if (player && typeof player.getPlayerState === "function") {
											if (player.getPlayerState() === YT.PlayerState.PLAYING) {
												const time = player.getCurrentTime();
												pausedPlayers[id] = time;
												player.pauseVideo();
											}
										}
									});
								} else {
									// Tab is visible again — resume paused videos
									Object.entries(pausedPlayers).forEach(([id, time]) => {
										const player = players[id];
										if (player && typeof time === "number") {
											player.seekTo(time, true);
											player.playVideo();
										}
									});

									// Clear memory
									Object.keys(pausedPlayers).forEach((key) => delete pausedPlayers[key]);
								}
							});

							// Store the cancelAnimationFrame function for cleanup
							intervalMap[firstIframe.id] = () => cancelAnimationFrame(rafId);
						},
					},
				});
			}

			if (lastIframe?.id && !players[lastIframe?.id]) {
				players[lastIframe.id] = new YT.Player(lastIframe.id, {
					playerVars: {
						controls: 0,
						rel: 0,
						fs: 0,
						mute: 1,
						enablejsapi: 1,
					},
					events: {
						onReady: (event) => {
							if (intervalMap[lastIframe.id]) {
								// Could be either setInterval or requestAnimationFrame
								if (typeof intervalMap[lastIframe.id] === "function") {
									intervalMap[lastIframe.id]();
								} else {
									clearInterval(intervalMap[lastIframe.id]);
								}
							}
							const youtubeUrl = new URL(event.target.g.src);
							const { start, end, loop } = Object.fromEntries(youtubeUrl.searchParams.entries());

							const startTime = parseFloat(start || 0);
							// Safe getDuration call with fallback
							let endTime;
							if (end) {
								endTime = parseFloat(end);
							} else if (typeof event.target.getDuration === 'function') {
								try {
									endTime = event.target.getDuration();
								} catch (e) {
									endTime = null;
								}
							}

							// Setup requestAnimationFrame loop for smoother performance
							let rafId;
							let lastCheckTime = 0;

							// Check video only every 200ms to reduce CPU usage
							const checkVideoTime = (timestamp) => {
								// Throttle checks to reduce CPU usage (check every 200ms)
								if (timestamp - lastCheckTime >= 200) {
									lastCheckTime = timestamp;
									const currentTime = event.target.getCurrentTime();

									if (loop && loop !== "0") {
										if (!isNaN(endTime) && Math.round(currentTime) >= endTime) {
											event.target.seekTo(startTime, true);
											event.target.playVideo();
										}
									} else {
										if (Math.ceil(currentTime) >= endTime) {
											children[0].children[0].classList.remove("hidden");
											children[0].children[0].classList.add("show");
											children[0].children[1].classList.remove("show");
											children[0].children[1].classList.add("hidden");
											cancelAnimationFrame(rafId);
											return;
										}
									}
								}

								// Continue the loop only if player is playing (state 1)
								if (event.target.getPlayerState() === YT.PlayerState.PLAYING) {
									rafId = requestAnimationFrame(checkVideoTime);
								}
							};

							// Start the animation frame loop
							rafId = requestAnimationFrame(checkVideoTime);

							// Handle state changes to manage rAF loop
							event.target.addEventListener("onStateChange", (stateEvent) => {
								if (stateEvent.data === YT.PlayerState.PLAYING) {
									// Resume animation frame loop when video plays
									rafId = requestAnimationFrame(checkVideoTime);
								} else if (
									stateEvent.data === YT.PlayerState.PAUSED ||
									stateEvent.data === YT.PlayerState.ENDED
								) {
									// Stop animation frame loop when video is paused or ended
									cancelAnimationFrame(rafId);
								}
							});

							const pausedPlayers = {}; // Track paused players and their current times

							document.addEventListener("visibilitychange", () => {
								if (document.hidden) {
									// Tab is hidden — pause all playing videos
									Object.entries(players).forEach(([id, player]) => {
										if (player && typeof player.getPlayerState === "function") {
											if (player.getPlayerState() === YT.PlayerState.PLAYING) {
												const time = player.getCurrentTime();
												pausedPlayers[id] = time;
												player.pauseVideo();
											}
										}
									});
								} else {
									// Tab is visible again — resume paused videos
									Object.entries(pausedPlayers).forEach(([id, time]) => {
										const player = players[id];
										if (player && typeof time === "number") {
											player.seekTo(time, true);
											player.playVideo();
										}
									});

									// Clear memory
									Object.keys(pausedPlayers).forEach((key) => delete pausedPlayers[key]);
								}
							});

							// Store the cancelAnimationFrame function for cleanup
							intervalMap[lastIframe.id] = () => cancelAnimationFrame(rafId);
						},
					},
				});
			}
		}
	});
}

function onYouTubeIframeAPIReady() {
	initYouTubePlayers();
	initHTML5VideoPlayers();
}

// Add mutation observer for dynamic content
const observeElements = function () {
	// Use MutationObserver to detect dynamically added elements
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes.length) {
				setTimeout(function () {
					initYouTubePlayers();
					initHTML5VideoPlayers();
					jQuery(".coca-bais-container:not(.initialized)").each(function () {
						jQuery(this).coca_imageCompare(jQuery(this).data("settings") || {});
						jQuery(this).addClass("initialized");
					});
				}, 500);
			}
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
};

// Initialize on document ready and again on window load
jQuery(document).ready(function () {
	observeElements();

	// Initialize existing sliders
	jQuery(".coca-bais-container:not(.initialized)").each(function () {
		// Remove any existing duplicate wrappers or controls
		const $container = jQuery(this);
		if (
			$container.parent().hasClass("coca-image-compare-wrapper") &&
			$container.parent().parent().hasClass("coca-image-compare-wrapper")
		) {
			// Unwrap once to fix double wrapping
			$container.unwrap();
		}

		// Remove any duplicate controls
		if (
			$container.next(".video-control-area").length > 0 &&
			$container.next(".video-control-area").next(".video-control-area").length > 0
		) {
			$container.next(".video-control-area").next(".video-control-area").remove();
		}

		// Initialize
		$container.coca_imageCompare(jQuery(this).data("settings") || {});
		$container.addClass("initialized");
	});
});

// Also initialize on window load (after all resources)
jQuery(window).on("load", function () {
	// Reinitialize players and sliders
	initYouTubePlayers();
	initHTML5VideoPlayers();

	jQuery(".coca-bais-container:not(.initialized)").each(function () {
		// Remove any existing duplicate wrappers or controls
		const $container = jQuery(this);
		if (
			$container.parent().hasClass("coca-image-compare-wrapper") &&
			$container.parent().parent().hasClass("coca-image-compare-wrapper")
		) {
			// Unwrap once to fix double wrapping
			$container.unwrap();
		}

		// Remove any duplicate controls
		if (
			$container.next(".video-control-area").length > 0 &&
			$container.next(".video-control-area").next(".video-control-area").length > 0
		) {
			$container.next(".video-control-area").next(".video-control-area").remove();
		}

		// Initialize
		$container.coca_imageCompare($container.data("settings") || {});
		$container.addClass("initialized");
	});
});

// Handle Elementor frontend init
jQuery(window).on("elementor/frontend/init", function () {
	if (typeof elementorFrontend !== "undefined") {
		elementorFrontend.hooks.addAction("frontend/element_ready/widget", function () {
			setTimeout(function () {
				// Clean up any duplicate elements first
				jQuery(".coca-bais-container").each(function () {
					const $container = jQuery(this);

					// Check for double wrapping
					if (
						$container.parent().hasClass("coca-image-compare-wrapper") &&
						$container.parent().parent().hasClass("coca-image-compare-wrapper")
					) {
						// Unwrap once to fix double wrapping
						$container.unwrap();
					}

					// Remove any duplicate controls
					if (
						$container.next(".video-control-area").length > 0 &&
						$container.next(".video-control-area").next(".video-control-area").length > 0
					) {
						$container.next(".video-control-area").next(".video-control-area").remove();
					}

					// Remove duplicate overlay and handle elements inside container
					const $overlays = $container.find(".coca-image-compare-overlay");
					if ($overlays.length > 1) {
						$overlays.not(":first").remove();
					}

					// Handle specific case for template-style07 with handle-bottom
					// Remove duplicate handle-wrapper elements
					const $handleWrappers = $container.find(".coca-image-compare-handle-wrapper");
					if ($handleWrappers.length > 1) {
						$handleWrappers.last().remove();
					}

					const $handles = $container.find(".coca-image-compare-handle");
					if ($handles.length > 1) {
						$handles.not(":first").remove();
					}
				});

				initYouTubePlayers();
				initHTML5VideoPlayers();

				jQuery(".coca-bais-container:not(.initialized)").each(function () {
					jQuery(this).coca_imageCompare(jQuery(this).data("settings") || {});
					jQuery(this).addClass("initialized");
				});
			}, 500);
		});
	}
});

window.jQuery.fn.coca_imageCompare = function (userOptions) {
	// Prevent multiple initializations on the same element
	if (this.hasClass("initialized")) {
		return this;
	}
	const jquery = window.jQuery;
	const defaultOptions = {
		default_offset_pct: 0.5,
		orientation: "horizontal",
		before_label: "Before",
		after_label: "After",
		before_image: "",
		after_image: "",
		indicator_image: "",
		classes: [],
		show_labels: 'yes',
		no_overlay: false,
		handle_bottom_only: false,
		move_slider_on_hover: false,
		move_with_handle_only: true,
		click_to_move: false,
		auto_slide_enabled: false,
		auto_slide_duration: 4,
		auto_slide_direction: 'back_and_forth',
		auto_slide_pause_on_hover: true,
		diagonal_direction: 'backslash',
	};

	const options = jquery.extend(defaultOptions, userOptions);

	return this.each(function () {
		let imgHeight;
		let imgWidth;
		let offsetY;
		let offsetX;
		const container = jquery(this);
		const orientation = options.orientation;

		let tagName;

		if (container.find("img")?.length) {
			tagName = "img";
		} else if (container.find("iframe")?.length) {
			tagName = "iframe";
		} else if (container.find("video")?.length) {
			tagName = "video";
		}

		const wrapperClassList = [].join.call(options.classes, " ");
		const classPrefix = "coca-image-compare";

		const beforeD = orientation === "vertical" ? "down" : "left";
		const afterD  = orientation === "vertical" ? "up" : "right";

		// Normalize orientation for class names: diagonal variants share one CSS class.
		const isDiagonal       = orientation === "diagonal";
		const wrapperOriClass  = isDiagonal ? "diagonal" : orientation;

		// Update wrapper class.
		const handleBottomClass = options.handle_bottom_only ? "handle-bottom" : "";
		const noOverlayClass = options.no_overlay ? "no-overlay" : "";

		// Check if already wrapped
		if (!container.parent().hasClass(`${classPrefix}-wrapper`)) {
			container.wrap(
				`<div class='${wrapperClassList} ${classPrefix}-wrapper ${classPrefix}-${wrapperOriClass} ${handleBottomClass}'></div>`,
			);
		}

		// const beforeImg = container.find("img:first");
		// const afterImg = container.find("img:last");
		const beforeImg = container.find(`${tagName}:first`);
		const afterImg = container.find(`${tagName}:last`);

		container.addClass(`${classPrefix}-container`);
		beforeImg.addClass(`${classPrefix}-before`);
		afterImg.addClass(`${classPrefix}-after`);

		// create an indicator image feature
		if (options.indicator_image.length) {
			container.append(jquery(options.indicator_image).addClass(`${classPrefix}-overlay-image`));
		}

		container.append(`<div class='${classPrefix}-overlay ${noOverlayClass}'></div>`);
		container.append(`<div class='${classPrefix}-handle'></div>`);

		const overlay = container.find(`.${classPrefix}-overlay`);
		const slider = container.find(`.${classPrefix}-handle`);

		// Set handle position.
		if (options.handle_bottom_only) {
			// For template-style07, check if it already has a handle wrapper
			if (options.classes && options.classes.includes("template-style07")) {
				// First clean up any existing handle wrappers or extra handles
				const existingWrappers = container.find(`.${classPrefix}-handle-wrapper`);
				if (existingWrappers.length > 0) {
					// Keep only the first wrapper
					existingWrappers.not(":first").remove();
					// Move the slider to the first wrapper if it's not already there
					if (!slider.parent().hasClass(`${classPrefix}-handle-wrapper`)) {
						existingWrappers.first().append(slider);
					}
				} else {
					// No wrappers exist, create one
					slider.wrap(`<div class='${classPrefix}-handle-wrapper'></div>`);
				}
			} else {
				// Normal behavior for other templates
				slider.wrap(`<div class='${classPrefix}-handle-wrapper'></div>`);
			}
		} else {
			slider.append(`<span class='${classPrefix}-${beforeD}-arrow'></span>`);
			slider.append(`<span class='${classPrefix}-${afterD}-arrow'></span>`);
		}

		// For diagonal: set the CSS custom property that controls the divider line angle.
		if (isDiagonal) {
			const diagAngle = options.diagonal_direction === 'slash' ? -45 : 45;
			container.parent()[0].style.setProperty('--bais-diagonal-angle', diagAngle + 'deg');
		}

		if (options.show_labels !== '') {
			const quote = options.before_label.indexOf("'") !== -1 ? '"' : "'";
			overlay.append(
				`<div class='${classPrefix}-before-label ${options.show_labels}' data-content=${quote}${options.before_label}${quote}></div>`,
			);
			overlay.append(
				`<div class='${classPrefix}-after-label ${options.show_labels}' data-content=${quote}${options.after_label}${quote}></div>`,
			);
		}

		const calcOffset = (pct) => {
			const [root] = container;

			// remove first.
			// if (root.querySelector("img:first-child").style.width) {
			// 	root.querySelector("img:first-child").style.width = "";
			// }
			if (root.querySelector(`${tagName}:first-child`).style.width) {
				root.querySelector(`${tagName}:first-child`).style.width = "";
			}

			const sampleImageWidth = root.querySelector(`${tagName}:first-child`).width;

			// [].forEach.call(root.querySelectorAll("img"), function (imageElement) {
			[].forEach.call(root.querySelectorAll(`${tagName}`), function (imageElement) {
				// Set image width.
				if (sampleImageWidth > root.clientWidth) {
					imageElement.style.width = `${root.clientWidth}px`;
				} else {
					imageElement.style.width = `${sampleImageWidth}px`;
				}

				// Set width and height when not exists.
				if (!imageElement.getAttribute("width")) {
					imageElement.setAttribute("width", imageElement.naturalWidth);
				}
				if (!imageElement.getAttribute("height")) {
					imageElement.setAttribute("height", imageElement.naturalHeight);
				}
			});

			// let width = root.querySelector("img:first-child").width;
			// let height = root.querySelector("img:first-child").height;
			let width = root.querySelector(`${tagName}:first-child`).width;

			// Derive height from HTML attributes to avoid the lazy-load placeholder trap.
			// img.height returns the rendered height based on the LOADED src's aspect ratio,
			// which for a placeholder (e.g. an 800×800 SVG) would be width×1 = wrong.
			// The HTML width/height attributes always reflect the real image dimensions.
			let height;
			const _firstImg = root.querySelector(`${tagName}:first-child`);
			const _attrW = parseInt(_firstImg.getAttribute('width'), 10);
			const _attrH = parseInt(_firstImg.getAttribute('height'), 10);
			if (_attrW > 0 && _attrH > 0) {
				height = Math.round(width * _attrH / _attrW);
			} else {
				height = _firstImg.height; // fallback for non-img elements (video/iframe)
			}

			if (container.hasClass("popup-loaded")) {
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;

				const targetWidth = windowWidth - windowWidth * 0.2;
				const targetHeight = windowHeight - windowHeight * 0.2;

				const ratio = width / height;

				if (ratio > targetWidth / targetHeight) {
					width = targetWidth;
					height = targetWidth / ratio;
				} else {
					height = targetHeight;
					width = targetHeight * ratio;
				}

				// [].forEach.call(root.querySelectorAll("img"), function (imageElement) {
				[].forEach.call(root.querySelectorAll(`${tagName}`), function (imageElement) {
					imageElement.style.width = `${width}px`;
				});

				width = root.querySelector(`${tagName}:first-child`).width;
				height = root.querySelector(`${tagName}:first-child`).height;
			}

			if (tagName !== "img") {
				width = container[0].clientWidth;
			}

			// Round values to prevent sub-pixel rendering issues (especially for iframes/videos)
			// Sub-pixel values cause shaking/jittering during auto-slide animation
			return {
				w: `${Math.round(width)}px`,
				h: `${Math.round(height)}px`,
				cw: `${Math.round(pct * width)}px`,
				ch: `${Math.round(pct * height)}px`,
			};
		};

		const adjustContainer = function (offset) {
			let hasAfter;

			if (tagName === "img") {
				hasAfter = true;
			} else {
				hasAfter = afterImg[0].id.includes("after");
			}

			// For iframes/videos: only clip the "before" element, leave "after" unclipped
			// This prevents shaking on Windows Chrome/Edge since the after iframe has no CSS changes
			const isIframeOrVideo = tagName === "iframe" || tagName === "video";

			if (isDiagonal) {
				// Use clip-path: polygon() for a slanted divider.
				// The handle moves left/right (offset.cw) and the divider line is diagonal.
				const widthPx  = parseFloat(offset.w);
				const heightPx = parseFloat(offset.h);
				const cwPx     = parseFloat(offset.cw);

				// scale = (w + h) / w ensures the line fully exits the image at cw=0 and cw=w
				// regardless of aspect ratio, AND keeps the handle exactly on the divider.
				// Derived from the line passing through (cw, handleTop) at ±45°:
				//   topX = cw·scale − h,  botX = cw·scale  (backslash \)
				//   topX = cw·scale,      botX = cw·scale − h  (slash /)
				const scale = 1 + heightPx / widthPx;

				// topX / botX are the x-coordinates where the diagonal line crosses
				// the top and bottom edges of the image.
				let topX, botX;
				if (options.diagonal_direction === 'slash') {
					// / direction: line goes top-right → bottom-left
					topX = cwPx * scale;
					botX = cwPx * scale - heightPx;
				} else {
					// \ direction (default): line goes top-left → bottom-right
					topX = cwPx * scale - heightPx;
					botX = cwPx * scale;
				}

				// Convert to percentage strings (clip-path is more reliable with %)
				const topXPct = ((topX / widthPx) * 100).toFixed(4) + '%';
				const botXPct = ((botX / widthPx) * 100).toFixed(4) + '%';

				const beforePoly = `polygon(0% 0%, ${topXPct} 0%, ${botXPct} 100%, 0% 100%)`;
				const afterPoly  = `polygon(${topXPct} 0%, 100% 0%, 100% 100%, ${botXPct} 100%)`;

				// Clear legacy CSS clip (rect) to avoid conflicts, then set clip-path.
				beforeImg.css({ 'clip': '', 'clip-path': beforePoly });
				if (isIframeOrVideo && beforeImg.parent().length) {
					beforeImg.parent().css({ 'clip': '', 'clip-path': beforePoly });
				}
				if (hasAfter && !isIframeOrVideo) {
					afterImg.css({ 'clip': '', 'clip-path': afterPoly });
				}
				if (isIframeOrVideo && afterImg.parent().length) {
					afterImg.parent().css({ 'clip': '', 'clip-path': afterPoly });
				}
			} else if (orientation === "vertical") {
				beforeImg.css("clip", `rect( 0, ${offset.w}, ${offset.ch}, 0)`);
				// Also update parent div clip for videos
				if (isIframeOrVideo && beforeImg.parent().length) {
					beforeImg.parent().css("clip", `rect( 0, ${offset.w}, ${offset.ch}, 0)`);
				}
				if (hasAfter && !isIframeOrVideo) {
					// Only clip after for images, not for iframes/videos
					afterImg.css("clip", `rect( ${offset.ch}, ${offset.w}, ${offset.h}, 0)`);
				}
				// Update after parent div clip for videos to allow full visibility
				if (isIframeOrVideo && afterImg.parent().length) {
					afterImg.parent().css("clip", `rect( ${offset.ch}, ${offset.w}, ${offset.h}, 0)`);
				}
			} else {
				beforeImg.css("clip", `rect( 0, ${offset.cw}, ${offset.h}, 0)`);
				// Also update parent div clip for videos
				if (isIframeOrVideo && beforeImg.parent().length) {
					beforeImg.parent().css("clip", `rect( 0, ${offset.cw}, ${offset.h}, 0)`);
				}

				if (hasAfter && !isIframeOrVideo) {
					// Only clip after for images, not for iframes/videos
					afterImg.css("clip", `rect( 0,  ${offset.w}, ${offset.h} , ${offset.cw})`);
				}
				// Update after parent div clip for videos to allow full visibility
				if (isIframeOrVideo && afterImg.parent().length) {
					afterImg.parent().css("clip", `rect( 0,  ${offset.w}, ${offset.h} , ${offset.cw})`);
				}
			}
			container.css("height", offset.h);
		};

		const adjustSliderWidth = function (offset) {
			container.css("max-width", offset.w);
			// Sync caption wrapper width so it aligns with the slider container.
			container.closest('.shortcode-container').find('.coca-bais-caption-wrapper').css('max-width', offset.w);
		};

		const adjustSlider = function (offset) {
			// Parse and round the position value to prevent sub-pixel jittering during auto-slide
			// Diagonal reuses horizontal (left) positioning since the handle moves along the X axis.
			const position = orientation === "vertical" ? offset.ch : offset.cw;
			const roundedPosition = `${Math.round(parseFloat(position))}px`;
			
			slider.css(orientation === "vertical" ? "top" : "left", roundedPosition);

			// For diagonal: move the handle vertically so it stays on the diagonal line.
			// Skip for handle_bottom_only (style07) — the knob lives inside the bottom bar
			// and must not be moved vertically out of it.
			if (isDiagonal && !options.handle_bottom_only) {
				const cwPx     = parseFloat(offset.cw);
				const widthPx  = parseFloat(offset.w);
				const heightPx = parseFloat(offset.h);
				// The handle tracks the point on the diagonal line at x = cw.
				// With effectiveCw = 2*cw - w/2, the line y at x=cw works out to:
				// Backslash (\): top = (1 - cw/w) * h  (moves top→bottom as handle goes right→left)
				// Slash    (/): top = (cw / w) * h      (moves top→bottom as handle goes left→right)
				let handleTop;
				if (options.diagonal_direction === 'slash') {
					handleTop = (cwPx / widthPx) * heightPx;
				} else {
					handleTop = (1 - cwPx / widthPx) * heightPx;
				}
				handleTop = Math.max(0, Math.min(heightPx, handleTop));
				slider.css('top', `${Math.round(handleTop)}px`);
			}

			adjustContainer(offset);
		};

		// Return the number specified or the min/max number if it outside the range given.
		const minMaxNumber = function (num, min, max) {
			return Math.max(min, Math.min(max, num));
		};

		// Calculate the slider percentage based on the position.
		const getSliderPercentage = function (positionX, positionY) {
			const vertical    = (positionY - offsetY) / imgHeight;
			const horizontal  = (positionX - offsetX) / imgWidth;
			// Diagonal uses the horizontal axis for dragging (same as horizontal orientation).
			const sliderPercentage = orientation === "vertical" ? vertical : horizontal;

			return minMaxNumber(sliderPercentage, 0, 1);
		};

		// Handle label visibility based on slider position
		const updateLabelVisibility = function() {
			// Get the current position of the slider
			const sliderPosition = parseFloat(slider.css(orientation === "vertical" ? "top" : "left"));

			// Hide the labels based on slider position
			if (orientation === "horizontal" || isDiagonal) {
				// Hide "Before" label when slider is close to left edge
				if (sliderPosition <= container.width() * 0.05) {
					container.find(".coca-image-compare-before-label").hide();
					container.closest(".label-horizontal-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".before-image-caption").css("opacity", 0);
				} else {
					container.find(".coca-image-compare-before-label").show();
					container.closest(".label-horizontal-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".before-image-caption").css("opacity", 1);
				}

				// Hide "After" label when slider is close to right edge
				if (sliderPosition >= container.width() * 0.95) {
					container.find(".coca-image-compare-after-label").hide();
					container.closest(".label-horizontal-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".after-image-caption").css("opacity", 0);
				} else {
					container.find(".coca-image-compare-after-label").show();
					container.closest(".label-horizontal-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".after-image-caption").css("opacity", 1);
				}
				
			} else if (orientation === "vertical") {
				// Hide "Before" label when slider is close to top edge
				if (sliderPosition <= container.height() * 0.05) {
					container.find(".coca-image-compare-before-label").hide();
					container.closest(".label-vertical-center, .label-vertical-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".before-image-caption").css("opacity", 0);
				} else {
					container.find(".coca-image-compare-before-label").show();
					container.closest(".label-vertical-center, .label-vertical-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".before-image-caption").css("opacity", 1);
				}

				// Hide "After" label when slider is close to bottom edge
				if (sliderPosition >= container.height() * 0.95) {
					container.find(".coca-image-compare-after-label").hide();
					container.closest(".label-vertical-center, .label-vertical-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".after-image-caption").css("opacity", 0);
				} else {
					container.find(".coca-image-compare-after-label").show();
					container.closest(".label-vertical-center, .label-vertical-middle, .coca-bais-shortcode, .elementor-widget-coca_bais_before_after_image_slider").find(".after-image-caption").css("opacity", 1);
				}
			}
		};

		// jquery( window ).on( 'resize.coca_image_compare', function() {
		// 	container.imagesLoaded().done( function() {
		// 		window.setTimeout( function() {
		// 			adjustSlider( calcOffset( options.default_offset_pct ) );
		// 			container.css( 'opacity', 1 );
		// 		}, 100 );
		// 	} );
		// } );

		if (tagName === "video") {
			if (!players[beforeImg[0].id]) {
				beforeImg[0].muted = true;
				players[beforeImg[0].id] = beforeImg[0];
			}

			if (!players[afterImg[0].id]) {
				afterImg[0].muted = true;
				players[afterImg[0].id] = afterImg[0];
			}
		}

		jQuery(document).ready(function ($) {
			// Add class to drag  feature
			$(".coca-bais-container").each(function () {
				let settings = $(this).attr("data-settings");
				if (settings) {
					try {
						let parsedSettings = JSON.parse(settings.replace(/&quot;/g, '"')); // Convert HTML entities to JSON

						if (parsedSettings.move_slider_on_hover === false) {
							$(this).addClass("coca-slider-hover-false");
						}
					} catch (error) {
						console.error("Error parsing data-settings:", error);
					}
				}
			});

			// Add class to hover feature
			$(".coca-bais-container").each(function () {
				let settings = $(this).attr("data-settings");
				if (settings) {
					try {
						let parsedSettings = JSON.parse(settings.replace(/&quot;/g, '"')); // Convert HTML entities to JSON

						if (parsedSettings.move_slider_on_hover === true) {
							$(this).addClass("coca-slider-hover-true");
						}
					} catch (error) {
						console.error("Error parsing data-settings:", error);
					}
				}
			});

			// Imagesloaded
			container.imagesLoaded().done(function () {
				window.setTimeout(function () {
					const offset = calcOffset(options.default_offset_pct);
					adjustSliderWidth(offset);
					adjustSlider(offset);
					container.css("opacity", 1);
				}, 100);
			});
		});

		offsetX = 0;
		offsetY = 0;
		imgWidth = 0;
		imgHeight = 0;

		// On move start event
		const onMoveStart = function (e) {
			if (isDiagonal) {
				// Diagonal: never cancel — the divider is at 45° so accept any drag direction.
			} else if (
				((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) &&
				orientation !== "vertical"
			) {
				e.preventDefault();
			} else if (
				((e.distX < e.distY && e.distX < -e.distY) || (e.distX > e.distY && e.distX > -e.distY)) &&
				orientation === "vertical"
			) {
				e.preventDefault();
			}
			container.addClass("active");
			offsetX = container.offset().left;
			offsetY = container.offset().top;
			imgWidth = beforeImg.width();
			imgHeight = beforeImg.height();
		};

		// On move event
		const onMove = function (e) {
			container.addClass("moving");

			if (container.hasClass("active")) {
				// Adjust the slider position based on mouse/touch movement
				adjustSlider(calcOffset(getSliderPercentage(e.pageX, e.pageY)));

				// Update label visibility after slider position changes
				updateLabelVisibility();

				// Add hover effect when the mouse is moving
				if (e.type === "mousemove") {
					jquery(this).find(`.${classPrefix}-overlay`).addClass("hover");
				}

				if (tagName !== "img") {
					const playPause = container.parent().find(".video-play-pause");
					const children = playPause[0].children;

					if (children[0].className === "show") {
						children[0].classList.remove("show");
						children[0].classList.add("hidden");
						children[1].classList.remove("hidden");
						children[1].classList.add("show");
					}

					const containerPosition =
						options.orientation === "vertical" ? container.height() / 2 : container.width() / 2;

					// Get current slider position
					const sliderPosition = options.orientation === "vertical" 
						? parseFloat(slider.css("top")) || 0
						: parseFloat(slider.css("left")) || 0;

					const hasBeforeVideo = beforeImg[0].id.includes("before");
					const hasAfterVideo = afterImg[0].id.includes("after");

					if (tagName === "iframe") {
						if (sliderPosition > containerPosition) {
							// Add safety checks for YouTube API methods
							try {
								const beforePlayer = players[beforeImg[0].id];
								if (beforePlayer && beforePlayer.g && beforePlayer.g.src) {
									const youtubeUrl = new URL(beforePlayer.g.src);
									const { start, end } = Object.fromEntries(youtubeUrl.searchParams.entries());
									
									// Safely get duration
									let endTime;
									if (end) {
										endTime = parseFloat(end);
									} else if (typeof beforePlayer.getDuration === 'function') {
										try {
											endTime = beforePlayer.getDuration();
										} catch (e) {
											endTime = null;
										}
									}

									// Check time and seek if needed
									if (start && endTime && typeof beforePlayer.getCurrentTime === 'function' && typeof beforePlayer.seekTo === 'function') {
										try {
											if (Math.round(beforePlayer.getCurrentTime()) >= endTime) {
												beforePlayer.seekTo(start);
											}
										} catch (e) {
											console.log('Error seeking video:', e);
										}
									}
								}
							} catch (error) {
								console.log('Error with YouTube player API:', error);
							}

							// Direct iframe control for video (YouTube API methods don't work after lazy loading)
							if (hasBeforeVideo && hasAfterVideo) {
								// Play before video, pause after video
								const beforeIframe = document.getElementById(beforeImg[0].id);
								const afterIframe = document.getElementById(afterImg[0].id);
								
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
								}
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								}
							} else {
								if (hasBeforeVideo) {
									// Play after video
									const afterIframe = document.getElementById(afterImg[0].id);
									if (afterIframe && afterIframe.contentWindow) {
										afterIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									}
								} else {
									// Pause before video
									const beforeIframe = document.getElementById(beforeImg[0].id);
									if (beforeIframe && beforeIframe.contentWindow) {
										beforeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
									}
									children[1].classList.remove("show");
									children[1].classList.add("hidden");
									children[0].classList.remove("hidden");
									children[0].classList.add("show");
								}
							}
						} else {
							// Add safety checks for YouTube API methods
							try {
								const afterPlayer = players[afterImg[0].id];
								const beforePlayer = players[beforeImg[0].id];
								
								if (afterPlayer && afterPlayer.g && afterPlayer.g.src) {
									const youtubeUrl = new URL(afterPlayer.g.src);
									const { start, end } = Object.fromEntries(youtubeUrl.searchParams.entries());

									// Safely get duration from before player
									let endTime;
									if (end) {
										endTime = parseFloat(end);
									} else if (beforePlayer && typeof beforePlayer.getDuration === 'function') {
										try {
											endTime = beforePlayer.getDuration();
										} catch (e) {
											endTime = null;
										}
									}

									// Check time and seek if needed
									if (start && endTime && typeof afterPlayer.getCurrentTime === 'function' && typeof afterPlayer.seekTo === 'function') {
										try {
											if (Math.round(afterPlayer.getCurrentTime()) >= endTime) {
												afterPlayer.seekTo(start);
											}
										} catch (e) {
											console.log('Error seeking video:', e);
										}
									}
								}
							} catch (error) {
								console.log('Error with YouTube player API:', error);
							}

							// Direct iframe control for video (YouTube API methods don't work after lazy loading)
							if (hasBeforeVideo && hasAfterVideo) {
								// Play after video, pause before video
								const afterIframe = document.getElementById(afterImg[0].id);
								const beforeIframe = document.getElementById(beforeImg[0].id);
								
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
								}
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								}
							} else {
								if (hasAfterVideo) {
									// Play before video (when slider is on after side)
									const beforeIframe = document.getElementById(beforeImg[0].id);
									if (beforeIframe && beforeIframe.contentWindow) {
										beforeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									}
								} else {
									// Pause after video
									const afterIframe = document.getElementById(afterImg[0].id);
									if (afterIframe && afterIframe.contentWindow) {
										afterIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
									}
									children[1].classList.remove("show");
									children[1].classList.add("hidden");
									children[0].classList.remove("hidden");
									children[0].classList.add("show");
								}
							}
						}
					}

					if (tagName === "video") {
						if (sliderPosition > containerPosition) {
							if (hasBeforeVideo && hasAfterVideo) {
								players[beforeImg[0].id].play();
								players[afterImg[0].id].pause();
							} else {
								if (hasBeforeVideo) {
									players[afterImg[0].id].play();
								} else {
									players[beforeImg[0].id].pause();
									children[1].classList.remove("show");
									children[1].classList.add("hidden");
									children[0].classList.remove("hidden");
									children[0].classList.add("show");
								}
							}
						} else {
							if (hasBeforeVideo && hasAfterVideo) {
								players[afterImg[0].id].play();
								players[beforeImg[0].id].pause();
							} else {
								if (hasAfterVideo) {
									players[beforeImg[0].id].play();
								} else {
									players[afterImg[0].id].pause();
									children[1].classList.remove("show");
									children[1].classList.add("hidden");
									children[0].classList.remove("hidden");
									children[0].classList.add("show");
								}
							}
						}
					}
				}
			}
		};

		// On move end event
		const onMoveEnd = function (e) {
			container.removeClass("active");
			if (e.type === "mouseleave") {
				jquery(this).find(`.${classPrefix}-overlay`).removeClass("hover");
			}
		};

		const moveTarget = options.move_with_handle_only ? slider : container;
		
		// Disable drag functionality if auto slide is enabled and pause on hover is disabled
		const isDragDisabled = options.auto_slide_enabled && !options.auto_slide_pause_on_hover;
		
		if (!isDragDisabled) {
			moveTarget.on("movestart", onMoveStart);
			moveTarget.on("move", onMove);
			moveTarget.on("mouseleave", function () {
				container.removeClass("moving");
			});
		}

		if (options.move_slider_on_hover && !isDragDisabled) {
			container.on("mouseenter", onMoveStart);
			container.on("mousemove", onMove);
			container.on("mouseleave", onMoveEnd);
		}

		slider.on("touchmove", function (e) {
			if (!isDragDisabled) {
				e.preventDefault();
			}
		});

		// container.find("img").on("mousedown", function (event) {
		container.find(`${tagName}`).on("mousedown", function (event) {
			if (!isDragDisabled) {
				event.preventDefault();
			}
		});

		if (options.click_to_move && !isDragDisabled) {
			container.on("click", function (e) {
				if (!e.target.closest(".popup-button")) {
					offsetX = container.offset().left;
					offsetY = container.offset().top;
					imgWidth = beforeImg.width();
					imgHeight = beforeImg.height();

					adjustSlider(getSliderPercentage(e.pageX, e.pageY));
				}
			});
		}

		if (tagName !== "img") {
			if (beforeImg.length !== 0 || afterImg.length !== 0) {
				const containerParent = container.parent();

				containerParent.append(
					`<div class="video-control-area">
					<div class="video-play-pause">
						<div title="play" class="show">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-play-icon lucide-play"
							>
								<polygon points="6 3 20 12 6 21 6 3" />
							</svg>
						</div>
						<div title="pause" class="hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-pause-icon lucide-pause"
							>
								<rect x="14" y="4" width="4" height="16" rx="1" />
								<rect x="6" y="4" width="4" height="16" rx="1" />
							</svg>
						</div>
					</div>
					<div class="video-sound">

					<div class="show" title="mute">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="lucide lucide-volume-x-icon lucide-volume-x"
							>
								<path
									d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
								/>
								<line x1="22" x2="16" y1="9" y2="15" />
								<line x1="16" x2="22" y1="9" y2="15" />
							</svg>
							
						</div>

						<div title="unmute" class="hidden">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume2-icon lucide-volume-2"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/><path d="M16 9a5 5 0 0 1 0 6"/><path d="M19.364 18.364a9 9 0 0 0 0-12.728"/></svg>
						</div>

						
					</div>
				</div>`,
				);

				const palyPause = containerParent.find(".video-play-pause");
				const videoSound = containerParent.find(".video-sound");

				palyPause.on("click", function () {
					console.log('🎬 Custom play button clicked');
					console.log('Available players:', Object.keys(players));
					console.log('beforeImg[0].id:', beforeImg[0].id);
					console.log('afterImg[0].id:', afterImg[0].id);
					console.log('beforeImg element:', beforeImg[0]);
					console.log('afterImg element:', afterImg[0]);
					console.log('players[beforeImg[0].id]:', players[beforeImg[0].id]);
					console.log('players[afterImg[0].id]:', players[afterImg[0].id]);
					
					const children = palyPause[0].children;

					const sliderPosition = parseFloat(slider.css(orientation === "vertical" ? "top" : "left"));

					if (children[0].className === "show") {
						children[0].classList.remove("show");
						children[0].classList.add("hidden");
						children[1].classList.remove("hidden");
						children[1].classList.add("show");

						const containerPosition =
							options.orientation === "vertical" ? container.height() / 2 : container.width() / 2;

						if (sliderPosition >= containerPosition) {
							if (tagName === "video") {
								players[beforeImg[0].id].play();
							}

							if (tagName === "iframe") {
								console.log('🎬 Trying to play iframe video');
								console.log('Before player ID:', beforeImg[0].id);
								console.log('Before player object:', players[beforeImg[0].id]);
								
								// Add safety checks for YouTube API methods
								const beforePlayer = players[beforeImg[0].id];
								console.log('beforePlayer:', beforePlayer);
								
								// Debug what methods are available
								console.log('Available methods on beforePlayer:');
								console.log('- playVideo:', typeof beforePlayer.playVideo);
								console.log('- getPlayerState:', typeof beforePlayer.getPlayerState);
								console.log('- mute:', typeof beforePlayer.mute);
								console.log('- unMute:', typeof beforePlayer.unMute);
								console.log('- getAllMethods:', Object.getOwnPropertyNames(beforePlayer));
								
								if (beforePlayer && typeof beforePlayer.playVideo === 'function') {
									console.log('✅ beforePlayer has playVideo method');
									try {
										// Only attempt URL parsing and time checks if player is fully ready
										if (beforePlayer.g && beforePlayer.g.src) {
											console.log('✅ Player has iframe source');
											const youtubeUrl = new URL(beforePlayer.g.src);
											const { start, end } = Object.fromEntries(youtubeUrl.searchParams.entries());
											
											// Check if getDuration method is available before calling
											let endTime = null;
											if (typeof beforePlayer.getDuration === 'function') {
												endTime = parseFloat(end || beforePlayer.getDuration());
											}
											
											// Check if getCurrentTime and seekTo methods are available
											if (start && endTime && 
												typeof beforePlayer.getCurrentTime === 'function' && 
												typeof beforePlayer.seekTo === 'function') {
												const currentTime = Math.round(beforePlayer.getCurrentTime());
												if (currentTime >= endTime) {
													beforePlayer.seekTo(start);
												}
											}
										}
										
										console.log('🎬 About to call playVideo on beforePlayer');
										
										// Simpler approach - just try to play without state check first
										beforePlayer.playVideo();
										console.log('✅ playVideo called successfully');
										
									} catch (error) {
										console.log('❌ Error with YouTube player API:', error);
										// Fallback: just try to play without time checks
										try {
											beforePlayer.playVideo();
											console.log('✅ Fallback playVideo succeeded');
										} catch (e2) {
											console.log('❌ Even fallback playVideo failed:', e2);
										}
									}
								} else {
									console.log('❌ beforePlayer not ready or no playVideo method');
									console.log('Trying alternative approaches...');
									
									// Alternative 1: Try to find playVideo method in prototype chain
									let playVideoMethod = null;
									let obj = beforePlayer;
									while (obj && !playVideoMethod) {
										if (obj.playVideo && typeof obj.playVideo === 'function') {
											playVideoMethod = obj.playVideo.bind(beforePlayer);
											break;
										}
										obj = Object.getPrototypeOf(obj);
									}
									
									if (playVideoMethod) {
										console.log('✅ Found playVideo in prototype chain');
										try {
											playVideoMethod();
											console.log('✅ Prototype playVideo succeeded');
										} catch (e) {
											console.log('❌ Prototype playVideo failed:', e);
										}
									} else {
										console.log('❌ No playVideo method found anywhere');
										
										// Alternative 2: Try direct iframe interaction
										const iframe = beforePlayer.g || document.getElementById(beforeImg[0].id);
										if (iframe && iframe.contentWindow) {
											console.log('🎬 Trying direct iframe postMessage');
											try {
												iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
												console.log('✅ Direct postMessage sent');
											} catch (e) {
												console.log('❌ Direct postMessage failed:', e);
											}
										} else {
											console.log('❌ No iframe found for direct interaction');
										}
									}
								}
							}
						} else {
							if (tagName === "video") {
								players[afterImg[0].id].play();
							}

							if (tagName === "iframe") {
								console.log('🎬 Trying to play after iframe video');
								console.log('After player ID:', afterImg[0].id);
								
								// Use direct iframe postMessage (YouTube API methods don't work after lazy loading)
								const afterIframe = document.getElementById(afterImg[0].id);
								if (afterIframe && afterIframe.contentWindow) {
									console.log('🎬 Sending playVideo to after iframe');
									afterIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									console.log('✅ After video playVideo command sent');
								} else {
									console.log('❌ After iframe not found or no contentWindow');
								}
							}
						}
					} else {
						children[1].classList.remove("show");
						children[1].classList.add("hidden");
						children[0].classList.remove("hidden");
						children[0].classList.add("show");
						if (tagName === "iframe") {
							// Use direct iframe postMessage for pause (YouTube API methods don't work after lazy loading)
							console.log('🎬 Sending pauseVideo to iframes');
							const beforeIframe = document.getElementById(beforeImg[0].id);
							const afterIframe = document.getElementById(afterImg[0].id);
							
							if (beforeIframe && beforeIframe.contentWindow) {
								beforeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								console.log('✅ Before video pause command sent');
							}
							if (afterIframe && afterIframe.contentWindow) {
								afterIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								console.log('✅ After video pause command sent');
							}
						}

						if (tagName === "video") {
							players[beforeImg[0].id].pause();
							players[afterImg[0].id].pause();
						}
					}
				});

				videoSound.on("click", function (e) {
					const children = videoSound[0].children;
					const sliderPosition = parseFloat(slider.css(orientation === "vertical" ? "top" : "left"));

					if (children[0].className === "show") {
						children[0].classList.remove("show");
						children[0].classList.add("hidden");
						children[1].classList.remove("hidden");
						children[1].classList.add("show");
						if (sliderPosition >= container.width() / 2) {
							if (tagName === "iframe") {
								// Use direct iframe postMessage for unmute (YouTube API methods don't work after lazy loading)
								console.log('🔊 Sending unMute to iframes (slider position check)');
								const beforeIframe = document.getElementById(beforeImg[0].id);
								const afterIframe = document.getElementById(afterImg[0].id);
								
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
									console.log('✅ Before video unMute command sent');
								}
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
									console.log('✅ After video unMute command sent');
								}
							}

							if (tagName === "video") {
								players[beforeImg[0].id].muted = false;
								players[afterImg[0].id].muted = false;
							}
						} else {
							if (tagName === "iframe") {
								// Use direct iframe postMessage for unmute (YouTube API methods don't work after lazy loading)
								console.log('🔊 Sending unMute to iframes');
								const afterIframe = document.getElementById(afterImg[0].id);
								const beforeIframe = document.getElementById(beforeImg[0].id);
								
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
									console.log('✅ After video unMute command sent');
								}
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
									console.log('✅ Before video unMute command sent');
								}
							} else {
								players[afterImg[0].id].muted = false;
								players[beforeImg[0].id].muted = false;
							}
						}
					} else {
						children[1].classList.remove("show");
						children[1].classList.add("hidden");
						children[0].classList.remove("hidden");
						children[0].classList.add("show");

						if (tagName === "iframe") {
							// Use direct iframe postMessage for mute (YouTube API methods don't work after lazy loading)
							console.log('🔇 Sending mute to iframes');
							const beforeIframe = document.getElementById(beforeImg[0].id);
							const afterIframe = document.getElementById(afterImg[0].id);
							
							if (beforeIframe && beforeIframe.contentWindow) {
								beforeIframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
								console.log('✅ Before video mute command sent');
							}
							if (afterIframe && afterIframe.contentWindow) {
								afterIframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
								console.log('✅ After video mute command sent');
							}
						} else {
							players[beforeImg[0].id].muted = true;
							players[afterImg[0].id].muted = true;
						}
					}
				});
			}
		}

		// Auto slide functionality
		if (options.auto_slide_enabled) {
			let autoSlideRequestId;
			let startTime;
			let isAutoSliding = true;
			let userHasInteracted = false;
			let animationDirection = options.auto_slide_direction === 'back_and_forth' ? -1 : 1; // Start moving left for back_and_forth since handle starts at right
			let pausedProgress = 0; // Store progress when paused
			let isPausedByHover = false;
			let lastUpdateTime = 0; // For throttling updates on Windows

			const duration = options.auto_slide_duration * 1000; // Convert to milliseconds
			
			// Throttle interval for iframes to prevent Windows shaking (update every 32ms = ~30fps instead of 60fps)
			const throttleInterval = (tagName === "iframe" || tagName === "video") ? 32 : 0;

			// For iframes/videos: ensure before is on top so we only need to clip before (not after)
			// This prevents shaking on Windows since after iframe has no CSS changes during animation
			if (tagName === "iframe" || tagName === "video") {
				beforeImg.parent().css({
					"position": "absolute",
					"z-index": "2"
				});
				afterImg.parent().css({
					"position": "absolute",
					"z-index": "1"
				});
			}

			// Easing function: ease-in-out (slow-fast-slow)
			const easeInOut = function(t) {
				return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
			};

			// Get current slider position (0-1)
			const getCurrentPosition = function() {
				const sliderPos = parseFloat(slider.css(orientation === 'vertical' ? 'top' : 'left'));
				const containerSize = orientation === 'vertical' ? container.height() : container.width();
				return containerSize > 0 ? Math.max(0, Math.min(1, sliderPos / containerSize)) : 0.5;
			};



			const animate = function(currentTime) {
				if (!startTime) startTime = currentTime;
				
				// Throttle updates for iframes/videos to prevent Windows shaking
				if (throttleInterval > 0 && (currentTime - lastUpdateTime) < throttleInterval) {
					// Skip this frame, request next
					if (isAutoSliding && !isPausedByHover && !userHasInteracted) {
						autoSlideRequestId = requestAnimationFrame(animate);
					}
					return;
				}
				lastUpdateTime = currentTime;
				
				const elapsed = currentTime - startTime;
				let progress = (elapsed / duration) + pausedProgress;

				// Handle different directions
				if (options.auto_slide_direction === 'left_to_right') {
					if (progress >= 1) {
						// Reset for continuous left to right
						startTime = currentTime;
						progress = 0;
						pausedProgress = 0;
					}
					const easedProgress = easeInOut(progress);
					adjustSlider(calcOffset(easedProgress));
				} 
				else if (options.auto_slide_direction === 'right_to_left') {
					if (progress >= 1) {
						// Reset for continuous right to left
						startTime = currentTime;
						progress = 0;
						pausedProgress = 0;
					}
					const easedProgress = easeInOut(progress);
					adjustSlider(calcOffset(1 - easedProgress));
				}
				else { // back_and_forth
					if (progress >= 1) {
						// Reverse direction and reset
						animationDirection *= -1;
						startTime = currentTime;
						progress = 0;
						pausedProgress = 0;
					}
					const easedProgress = easeInOut(progress);
					const position = animationDirection === 1 ? easedProgress : (1 - easedProgress);
					adjustSlider(calcOffset(position));
					
					// Add video control for auto slide animation
					if (tagName === "iframe") {
						const containerPosition = options.orientation === "vertical" ? container.height() / 2 : container.width() / 2;
						const sliderPosition = options.orientation === "vertical" 
							? parseFloat(slider.css("top")) || 0
							: parseFloat(slider.css("left")) || 0;

						const hasBeforeVideo = beforeImg[0].id.includes("before");
						const hasAfterVideo = afterImg[0].id.includes("after");

						if (sliderPosition > containerPosition) {
							// Add safety checks for YouTube API methods (same as manual dragging)
							try {
								const beforePlayer = players[beforeImg[0].id];
								if (beforePlayer && beforePlayer.g && beforePlayer.g.src) {
									const youtubeUrl = new URL(beforePlayer.g.src);
									const { start, end } = Object.fromEntries(youtubeUrl.searchParams.entries());
									
									// Safely get duration
									let endTime;
									if (end) {
										endTime = parseFloat(end);
									} else if (typeof beforePlayer.getDuration === 'function') {
										try {
											endTime = beforePlayer.getDuration();
										} catch (e) {
											endTime = null;
										}
									}

									// Check time and seek if needed
									if (start && endTime && typeof beforePlayer.getCurrentTime === 'function' && typeof beforePlayer.seekTo === 'function') {
										try {
											if (Math.round(beforePlayer.getCurrentTime()) >= endTime) {
												beforePlayer.seekTo(start);
											}
										} catch (e) {
											console.log('Error seeking video:', e);
										}
									}
								}
							} catch (error) {
								console.log('Error with YouTube player API:', error);
							}

							// Direct iframe control for video (YouTube API methods don't work after lazy loading)
							if (hasBeforeVideo && hasAfterVideo) {
								// Play before video, pause after video
								const beforeIframe = document.getElementById(beforeImg[0].id);
								const afterIframe = document.getElementById(afterImg[0].id);
								
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
								}
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								}
							} else {
								if (hasBeforeVideo) {
									// Play after video
									const afterIframe = document.getElementById(afterImg[0].id);
									if (afterIframe && afterIframe.contentWindow) {
										afterIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									}
								} else {
									// Pause before video
									const beforeIframe = document.getElementById(beforeImg[0].id);
									if (beforeIframe && beforeIframe.contentWindow) {
										beforeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
									}
								}
							}
						} else {
							// Add safety checks for YouTube API methods  
							try {
								const afterPlayer = players[afterImg[0].id];
								const beforePlayer = players[beforeImg[0].id];
								
								if (afterPlayer && afterPlayer.g && afterPlayer.g.src) {
									const youtubeUrl = new URL(afterPlayer.g.src);
									const { start, end } = Object.fromEntries(youtubeUrl.searchParams.entries());

									// Safely get duration
									let endTime;
									if (end) {
										endTime = parseFloat(end);
									} else if (typeof afterPlayer.getDuration === 'function') {
										try {
											endTime = afterPlayer.getDuration();
										} catch (e) {
											endTime = null;
										}
									}

									// Check time and seek if needed
									if (start && endTime && typeof afterPlayer.getCurrentTime === 'function' && typeof afterPlayer.seekTo === 'function') {
										try {
											if (Math.round(afterPlayer.getCurrentTime()) >= endTime) {
												afterPlayer.seekTo(start);
											}
										} catch (e) {
											console.log('Error seeking video:', e);
										}
									}
								}
							} catch (error) {
								console.log('Error with YouTube player API:', error);
							}

							// Direct iframe control for video (YouTube API methods don't work after lazy loading)
							if (hasBeforeVideo && hasAfterVideo) {
								// Play after video, pause before video
								const beforeIframe = document.getElementById(beforeImg[0].id);
								const afterIframe = document.getElementById(afterImg[0].id);
								
								if (afterIframe && afterIframe.contentWindow) {
									afterIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
								}
								if (beforeIframe && beforeIframe.contentWindow) {
									beforeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
								}
							} else {
								if (hasAfterVideo) {
									// Play before video
									const beforeIframe = document.getElementById(beforeImg[0].id);
									if (beforeIframe && beforeIframe.contentWindow) {
										beforeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
									}
								} else {
									// Pause after video
									const afterIframe = document.getElementById(afterImg[0].id);
									if (afterIframe && afterIframe.contentWindow) {
										afterIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
									}
								}
							}
						}
					}
					
					// Handle MP4/HTML5 videos
					if (tagName === "video") {
						const containerPosition = options.orientation === "vertical" ? container.height() / 2 : container.width() / 2;
						const sliderPosition = options.orientation === "vertical" 
							? parseFloat(slider.css("top")) || 0
							: parseFloat(slider.css("left")) || 0;

						const hasBeforeVideo = beforeImg[0].id.includes("before");
						const hasAfterVideo = afterImg[0].id.includes("after");
						
						if (sliderPosition > containerPosition) {
							if (hasBeforeVideo && hasAfterVideo) {
								players[beforeImg[0].id].play();
								players[afterImg[0].id].pause();
							} else {
								if (hasBeforeVideo) {
									players[afterImg[0].id].play();
								} else {
									players[beforeImg[0].id].pause();
								}
							}
						} else {
							if (hasBeforeVideo && hasAfterVideo) {
								players[afterImg[0].id].play();
								players[beforeImg[0].id].pause();
							} else {
								if (hasAfterVideo) {
									players[beforeImg[0].id].play();
								} else {
									players[afterImg[0].id].pause();
								}
							}
						}
					}
				}

				// Update label visibility after slider position changes
				updateLabelVisibility();

				// Continue animation if still sliding
				if (isAutoSliding && !isPausedByHover && !userHasInteracted) {
					autoSlideRequestId = requestAnimationFrame(animate);
				}
			};

			const startAutoSlide = function() {
				if (!isAutoSliding || isPausedByHover) return;
				
				if (pausedProgress === 0) {
					startTime = null; // Reset start time only if not resuming
				}
				autoSlideRequestId = requestAnimationFrame(animate);
			};

			const stopAutoSlide = function() {
				if (autoSlideRequestId) {
					cancelAnimationFrame(autoSlideRequestId);
				}
			};

			const pauseAutoSlide = function() {
				isPausedByHover = true;
				
				// Calculate current progress to resume from same position
				if (startTime) {
					const currentTime = performance.now();
					const elapsed = currentTime - startTime;
					const currentProgress = (elapsed / duration) + pausedProgress;
					
					// Store progress for resume
					pausedProgress = currentProgress % 1; // Keep within 0-1 range
				}
				
				stopAutoSlide();
			};

			const resumeAutoSlide = function() {
				isPausedByHover = false;
				isAutoSliding = true;
				startTime = null; // Will be set in animate function
				startAutoSlide();
			};

			// Pause on hover if enabled
			if (options.auto_slide_pause_on_hover) {
				container.on('mouseenter', pauseAutoSlide);
				container.on('mouseleave', function() {
					// Reset user interaction flag when mouse leaves
					// This allows auto slide to resume even after manual interaction
					userHasInteracted = false;
					resumeAutoSlide();
				});
				
				// Only add manual interaction handlers if pause on hover is enabled
				// Pause (don't permanently stop) auto slide when user interacts manually
				moveTarget.on('movestart', function() {
					userHasInteracted = true;
					pauseAutoSlide();
				});

				// Update position when user manually moves the slider
				moveTarget.on('move', function() {
					if (userHasInteracted) {
						// Continuously update the position during manual drag
						const currentPosition = getCurrentPosition();
						
						// Update progress based on direction for smooth resume
						if (options.auto_slide_direction === 'left_to_right') {
							pausedProgress = currentPosition;
						} 
						else if (options.auto_slide_direction === 'right_to_left') {
							pausedProgress = 1 - currentPosition;
						}
						else { // back_and_forth
							// Determine direction and progress based on current position
							if (currentPosition <= 0.5) {
								animationDirection = 1;
								pausedProgress = currentPosition;
							} else {
								animationDirection = -1;
								pausedProgress = 1 - currentPosition;
							}
						}
					}
				});

				// Add touch event handling for mobile devices
				// Resume auto slide when touch ends (user lifts finger)
				moveTarget.on('touchend', function() {
					// Small delay to ensure drag is complete
					setTimeout(function() {
						userHasInteracted = false;
						resumeAutoSlide();
					}, 300);
				});

				// Also handle when touch is cancelled
				moveTarget.on('touchcancel', function() {
					setTimeout(function() {
						userHasInteracted = false;
						resumeAutoSlide();
					}, 300);
				});
			}

			// Set initial position to show before content first (handle at 100% position)
			adjustSlider(calcOffset(1.0)); // Start with handle at the end (right side)
			updateLabelVisibility(); // Update labels for initial position
			
			// Set custom play/pause button to "playing" state and keep it there for auto slide
			const playPause = container.parent().find(".video-play-pause");
			if (playPause.length > 0 && playPause[0].children) {
				const children = playPause[0].children;
				// Show pause/stop icon (playing state) and hide play icon
				children[0].classList.remove("show");
				children[0].classList.add("hidden");
				children[1].classList.remove("hidden");
				children[1].classList.add("show");
				
				// Disable click functionality during auto slide
				playPause.off('click').on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					// Do nothing - button stays in playing state during auto slide
					return false;
				});
			}
			
			// Start auto sliding after initial setup
			setTimeout(startAutoSlide, 0.1);
		}

		window.jQuery(window).trigger("resize.coca_image_compare");
	});
};

// Listen for lazy-loaded iframe events and reinitialize YouTube players only
document.addEventListener('baislIframeLoaded', function(event) {
	const iframe = event.detail.iframe;
	const container = event.detail.container;
	
	if (container && iframe && iframe.src && iframe.src.includes('youtube.com')) {
		// Find the slider container
		const sliderContainer = container.closest('.coca-image-compare-container') || 
						   container.closest('[data-bais-lazy-id]') ||
						   container.closest('[class*="coca-bais-"]');
		
		if (sliderContainer) {
			// Small delay to ensure iframe is fully loaded
			setTimeout(() => {
				// Only reinitialize YouTube players for this specific iframe
				if (iframe.id && !players[iframe.id] && typeof YT !== 'undefined' && YT.Player) {
					try {
						players[iframe.id] = new YT.Player(iframe.id, {
							events: {
								onReady: function(event) {
									console.log('YouTube player ready for:', iframe.id);
								},
								onError: function(event) {
									console.error('YouTube player error for:', iframe.id, event);
								}
							}
						});
					} catch (error) {
						console.error('Error creating YouTube player:', error);
					}
				}
			}, 200);
		}
	}
});

// Initialize HTML5 videos when document is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHTML5VideoPlayers);
} else {
	initHTML5VideoPlayers();
}

// Function to cleanup player references for a specific container
function cleanupPlayersForContainer(container) {
	const iframes = container.querySelectorAll('iframe[id]');
	const videos = container.querySelectorAll('video[id]');
	
	// Remove iframe player references
	iframes.forEach(iframe => {
		if (iframe.id && players[iframe.id]) {
			try {
				// Try to destroy YouTube player if it exists
				if (typeof players[iframe.id].destroy === 'function') {
					players[iframe.id].destroy();
				}
			} catch (e) {
				// Silent error handling for player destruction
			}
			delete players[iframe.id];
		}
	});
	
	// Remove video player references
	videos.forEach(video => {
		if (video.id && players[video.id]) {
			delete players[video.id];
		}
	});
}

// Function to initialize YouTube players for a specific container
function initYouTubePlayersForContainer(container) {
	// Find YouTube iframes in this container
	const iframes = container.querySelectorAll('iframe[src*="youtube.com"], iframe[data-src*="youtube.com"]');
	
	iframes.forEach(iframe => {
		if (iframe.src && iframe.src.includes('youtube.com') && iframe.id) {
			// Only create player if it doesn't exist and YouTube API is ready
			if (!players[iframe.id] && typeof YT !== 'undefined' && YT.Player) {
				try {
					players[iframe.id] = new YT.Player(iframe.id, {
						events: {
							onReady: function(event) {
								console.log('YouTube player ready for:', iframe.id);
							},
							onError: function(event) {
								console.error('YouTube player error for:', iframe.id, event);
							}
						}
					});
				} catch (error) {
					console.error('Error creating YouTube player:', error);
				}
			}
		}
	});
}